import { render, staticRenderFns } from "./ConfirmableButton.vue?vue&type=template&id=6f2a5fc6&scoped=true&"
import script from "./ConfirmableButton.vue?vue&type=script&lang=js&"
export * from "./ConfirmableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2a5fc6",
  null
  
)

export default component.exports